<div class="records-page dashboard-page">
    <div class="dashboard-page__header">
        <div class="section-tabs-rail dashboard-tabs" fxLayout="row wrap" fxLayoutAlign="start center">
            <button
                *ngFor="let tab of tabs"
                type="button"
                class="section-tab-button dashboard-tab"
                [class.section-tab-button--active]="activeTabId === tab.id"
                (click)="selectTab(tab.id)">
                <h2>{{ tab.titleKey | translate }}</h2>
            </button>
        </div>
    </div>

    <div class="details-tab-surface dashboard-panel dashboard-panel--embedded" *ngIf="activeTabId === 'tasks' && !externalUser">
        <app-tasks-dashboard></app-tasks-dashboard>
    </div>

    <div class="details-tab-surface dashboard-panel dashboard-panel--embedded" *ngIf="activeTabId === 'dmsDashboard' && !externalUser">
        <app-dms-dashboard></app-dms-dashboard>
    </div>

    <div class="details-tab-surface dashboard-panel dashboard-panel--iframe" *ngIf="((activeTabId === 'dashboard') && !externalUser) || (activeTabId === 'salesPipeline')">
        <iframe
            class="dashboard-iframe"
            allow="clipboard-read; clipboard-write"
            [style.height]="dashboardHeight"
            [src]="iframeSrc"
            scrolling="yes"></iframe>
    </div>

    <div *ngIf="activeTabId === 'campaignReports'" class="dashboard-stack details-tab-surface dashboard-panel dashboard-panel--reports">
        <div class="campaignSelect">
            <label for="campaignSelector">{{ 'SELECT_CAMPAIGN' | translate }}:</label>
            <ng-select
                id="campaignSelector"
                [clearable]="false"
                [attr.aria-label]="'SELECT_CAMPAIGN' | translate"
                [placeholder]="'SELECT_PLACEHOLDER' | translate"
                [items]="campaignsData"
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="selectedCampaignId"
                (ngModelChange)="updateReportView($event)">
            </ng-select>
        </div>
        <div *ngIf="selectedCampaignId" class="details-tab-surface details-tab-surface--report dashboard-report-surface">
            <app-report-view
                [Iid]="selectedCampaignId">
            </app-report-view>
        </div>
    </div>

    <div class="details-tab-surface dashboard-panel dashboard-panel--reports" *ngIf="activeTabId === 'overview'">
        <app-reports-brand-overview [defaultReportPeriod]="'Past 30 Days'"></app-reports-brand-overview>
    </div>

    <div class="details-tab-surface dashboard-panel dashboard-panel--reports dashboard-panel--rollup" *ngIf="activeTabId === 'rollupReport'">
        <app-reports-rollup-main [embedded]="true"></app-reports-rollup-main>
    </div>

    <div class="details-tab-surface details-tab-surface--tight dashboard-panel dashboard-panel--widgets" *ngIf="activeTabId === 'widgets'">
        <div class="dashboard-widgets-shell">
            <div class="dashboard-widgets-header">
                <div class="dashboard-widgets-header__primary">
                <div class="dashboard-widgets-header__headline">
                        <span class="dashboard-widgets-header__eyebrow">{{ 'WIDGETS' | translate }}</span>
                        <h3 class="dashboard-widgets-header__title">{{ 'YOUR_STAT_CARDS' | translate }}</h3>
                    </div>
                </div>
                <div class="dashboard-widgets-header__aside">
                    <div class="dashboard-widgets-header__actions">
                        <button type="button" class="blue-button" (click)="addWidgetClick()">{{ 'ADD_WIDGET' | translate }}</button>
                        <button type="button" class="blue-button" (click)="changeLayoutClick()">{{ changeLayoutStarted ? ('FINISH_CHANGE_LAYOUT' | translate) : ('CHANGE_LAYOUT' | translate) }}</button>
                    </div>
                </div>
            </div>

            <div class="dashboard-widgets d-flex flex-wrap" [class.dashboard-widgets--empty]="!widgets?.length" [sortablejs]="widgets" [sortablejsOptions]="sortableOptions">
                <ng-container *ngIf="widgets?.length; else widgetsEmptyState">
                    <ng-container *ngFor="let widget of widgets;">
                        <app-widget [widget]="widget" [id]='widget.id'></app-widget>
                    </ng-container>
                </ng-container>
                <ng-template #widgetsEmptyState>
                    <div class="dashboard-widgets-empty">
                        <span class="dashboard-widgets-empty__eyebrow">{{ 'NO_WIDGETS' | translate }}</span>
                        <p class="dashboard-widgets-empty__copy">{{ 'NO_WIDGETS_DESCRIPTION' | translate }}</p>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div class="details-tab-surface dashboard-panel dashboard-panel--embedded" *ngIf="activeTabId === 'managerDash'">
        <app-manager-dash
          [externalUser]="externalUser"
          [iReportFormat]="iReportFormat"
        ></app-manager-dash>
    </div>
</div>
